import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import get from 'lodash/get';

import { getActiveCrawlerSection } from '@hydra/utils/parseRouteParams';

import IssueCounterRow from '@hydra/routes/crawler/components/IssueCounterRow';

export class CanonicalCategory extends React.Component {
  static propTypes = {
    children: PropTypes.element,
    params: PropTypes.shape({
      lang: PropTypes.string,
      url: PropTypes.string
    }).isRequired,
    project: PropTypes.shape({
      host: PropTypes.string,
      crawl: PropTypes.shape({
        canonicalCategory: PropTypes.shape({
          countCanonicalIssues: PropTypes.number,
          countBrokenHreflangs: PropTypes.number
        })
      })
    }),
    location: PropTypes.object,
    url: PropTypes.string
  }

  static childContextTypes = {
    location: PropTypes.object
  }

  getChildContext () {
    return {
      location: this.props.location
    };
  }

  getCounters (props) {
    const { lang, url } = props.params;
    const activeSection = getActiveCrawlerSection(props.routes);
    const baseUrl = `/${lang}/crawler/${encodeURIComponent(url)}/canonical`;
    const crawlNode = get(props, 'project.crawls.edges[0].node', {});

    return [
      {
        active: activeSection === 'canonical-issues',
        amount: crawlNode.countCanonicalIssues,
        label: <Translate content='crawler_canonical_issues' />,
        link: `${baseUrl}/canonical-issues`,
        name: 'canonical-issues'
      },
      {
        active: activeSection === 'broken-hreflang-issues',
        amount: crawlNode.countBrokenHreflangs,
        label: <Translate content='crawler_broken_hreflang_issues' />,
        link: `${baseUrl}/broken-hreflang-issues`,
        name: 'broken-hreflang-issues'
      }
    ];
  }

  render () {
    const { children } = this.props;

    return (
      <div className='nr-crawler-canonical-category'>
        <IssueCounterRow counters={this.getCounters(this.props)} />
        {children}
      </div>
    );
  }
}

export default createFragmentContainer(CanonicalCategory, {
  project: graphql`
    fragment CanonicalCategory_project on Project {
      host
      crawls (offset: 0, limit: 1) {
        edges {
          cursor,
          node {
            countCanonicalIssues
            countBrokenHreflangs
          }
        }
      }
    }
  `
});
